import { api } from './client'

export interface ResourceSummary {
  total: number
  by_type: Record<string, { total: number; running?: number; stopped?: number; error?: boolean }>
  critical_count: number
}

export interface TicketSummary {
  total: number
  by_status: Record<string, number>
  open: number
  approved: number
  rejected: number
}

export interface AlertsSummary {
  total: number
  critical: number
  warning: number
  alerts: { type: string; severity: string; message: string }[]
}

export interface DashboardKpis {
  resources: ResourceSummary
  tickets: TicketSummary
  alerts: AlertsSummary
}

export interface CostByService {
  services: { service: string; cost_usd: number }[]
  total_usd: number
}

export interface CostDaily {
  data: { month: string; cost_usd: number | null }[]
  days: number
}

export interface CapacityMetric {
  current_pct: number | null
  growth_rate_per_day: number | null
  days_until_threshold: number | null
}

export interface CapacityForecastData {
  storage: CapacityMetric
  connections: CapacityMetric
  cpu: CapacityMetric
}

export const dashboardApi = {
  getResourceSummary: (tenantId: number) =>
    api.get<ResourceSummary>(`/v1/tenants/${tenantId}/dashboard/resource-summary`).then(r => r.data),

  getTicketSummary: (tenantId: number) =>
    api.get<TicketSummary>(`/v1/tenants/${tenantId}/dashboard/ticket-summary`).then(r => r.data),

  getCostByService: (tenantId: number) =>
    api.get<CostByService>(`/v1/tenants/${tenantId}/dashboard/cost-by-service`).then(r => r.data),

  getCostDaily: (tenantId: number, days = 30) =>
    api.get<CostDaily>(`/v1/tenants/${tenantId}/dashboard/cost-daily?days=${days}`).then(r => r.data),

  getAlertsSummary: (tenantId: number) =>
    api.get<AlertsSummary>(`/v1/tenants/${tenantId}/dashboard/alerts-summary`).then(r => r.data),

  getKpis: (tenantId: number) =>
    api.get<DashboardKpis>(`/v1/tenants/${tenantId}/dashboard/kpis`).then(r => r.data),

  getCapacityForecast: (tenantId: number, dbIdentifier: string) =>
    api.get<CapacityForecastData>(`/v1/tenants/${tenantId}/rds/${dbIdentifier}/capacity-forecast`).then(r => r.data),
}
